import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import React from 'react';

import * as Interfaces from 'app/interfaces';
import * as Steps from '..';
import { constants } from 'app/utils';

const Component = React.lazy(() => import('./Error'));

const Step: StepProps<Interfaces.Common.RedemptionFormValues> = {
  id: 'error',
  title: constants.RedemptionPage.title,
  stepName: 'Done',
  navigation: {
    normal: [
      {
        content: 'Back',
        type: 'secondary',
        onClick: (context, formProps) => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: Steps.Review.Step.id,
            values: formProps.values
          });
        }
      }
    ]
  },
  Component
};

export { Step };
